import React, { useCallback } from 'react';
import { BestPractice } from './types';
import { AiAgent } from '../aiAgentCenter/aiAgentsConsts';
import BestPracticeCardBase from './BestPracticeCardBase';

interface SelectableBestPracticeCardProps {
  bestPractice: BestPractice;
  isCustom: boolean;
  index: number;
  onIsPristineChange?: (isPristine: boolean) => void;
  agent?: AiAgent | null;
  selectedBestPracticeIds: string[];
  onBestPracticesChange: (bestPracticeIds: string[]) => void;
}

const SelectableBestPracticeCard: React.FC<SelectableBestPracticeCardProps> = ({
  bestPractice,
  isCustom,
  index,
  onIsPristineChange,
  agent,
  selectedBestPracticeIds,
  onBestPracticesChange,
}) => {
  const isSelected = selectedBestPracticeIds.includes(bestPractice.id);

  const handleToggleActive = useCallback(
    (isActive: boolean) => {
      const updatedIds = isActive
        ? [...selectedBestPracticeIds, bestPractice.id]
        : selectedBestPracticeIds.filter((id) => id !== bestPractice.id);
      onBestPracticesChange(updatedIds);
    },
    [selectedBestPracticeIds, bestPractice.id, onBestPracticesChange],
  );

  return (
    <BestPracticeCardBase
      bestPractice={bestPractice}
      isCustom={isCustom}
      index={index}
      onIsPristineChange={onIsPristineChange}
      agent={agent}
      onToggleActive={handleToggleActive}
      isToggleChecked={isSelected}
      showToggle={true}
    />
  );
};

export default SelectableBestPracticeCard;
